export const CHAT_APP = {
  CATEGORY: "Category",
  CHAT: "chat",
  CONTACT: "Contact No",
  CONTENT_TYPE: "text/plain",
  DEPRECATED: "deprecated",
  EMAIL_ADDRESS: "Email Address",
  ENTER: "Enter",
  FULL_NAME: "Full Name",
  INSTRUCTION1:
    "Please provide the following information to initiate the chat with our experts.",
  INSTRUCTION2: "Our agents are available to serve you 24/7.",
  PARTNER_WITH_US: "PartnerWithUs",
  QUERY_DESCRIPTION: "Query Description",
  START_CHAT: "Start Chat",
  TEXT: "text",
  TWO: "2",
  TYPE_OF_QUERY: "Type of Query",
  VALUE: "value",
  WORK_GROUP: "Workgroup",
};

export const MODAL_BODY = {
  FORM: 1,
  LIVE_CHAT: 2,
  THANK_YOU: 3,
  FEEDBACK: 4,
};

export const LANGUAGE = {
  AR: "ar",
  AR_SA: "ar_SA",
  ARABIC: "Arabic",
  ENGLISH: "English",
  EN: "en",
  EN_US: "en_US",
};

export const RESPONSE_STATUS_CODE = {
  STATUS_200: 200,
};

export const MESSAGE_TYPE = {
  TYPING_INDICATOR: "typingIndicator",
  WEB_USER: "WebUser",
  SYSTEM: "System"
};

export const RESPONSE_TYPE = {
  SUCCESS: "success",
  FAILURE: "failure",
};

export const SESSION_STORAGE_KEYS = {
  CHAT_LIST: "chatList",
  PARTICIPANT_ID: "participantId",
  USER_DETAILS: "userDetails",
  MODAL_BODY_INDEX: "modalBodyInex",
  SURVEY_DETAILS: "surveyDetails",
  QUESTION_INDEX: "questionIndex",
};

export const QUESTION_ORDER = {
  OVERALL_EFFORT: 1,
  OVERALL_SATISFACTION: 2,
  LIKE_TO_SUGGEST: 3,
};

export const RATING = {
  VERY_HAPPY: "5",
  HAPPY: "4",
  NEUTRAL: "3",
  UNHAPPY: "2",
  NOT_HAPPY: "1",
};
